module.exports=function(){
    var clipboard = new ClipboardJS('.copy');
    clipboard.on('success', function(e) {
        alert('邀请文字已复制成功，直接粘贴发送给朋友即可！')
    });
};